<template>
  <!-- 店铺信息-添加案例 -->
  <div class="Case-box">
    <!-- 案例编辑 标题 -->
    <div class="top-title">
      <p class="title">店铺案例</p>
      <div class="Back" @click="handelBack">
        <div class="Back-style">
          <div></div>
          <p>返回店铺</p>
        </div>
      </div>
      <div class="delete"></div>
    </div>
    <!-- 案例编辑输入区 -->
    <div class="form-box">
      <div class="aroundModule">
        <!-- 案例名称 -->
        <div class="container">
          <p class="container-title">
            <span style="color: red">*</span>案例名称：
          </p>
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </div>
        <!-- 案例标签 -->
        <div class="container">
          <p class="container-title">
            <span style="color: red">*</span>案例标签：
          </p>
          <el-select v-model="ruleForm.value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 案例价格： -->
        <div class="container">
          <p class="container-title">
            <span style="color: red">*</span>案例价格：
          </p>
          <el-input v-model="ruleForm.Price" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="aroundModule">
        <div class="container">
          <span style="color: red">*</span>封面：
          <div class="Upload-box">
            <img :src="imgSrc" alt="" v-if="imgSrc != ''" />
            <input
              type="file"
              @change="onFileChange"
              ref="clearFile"
              id="file"
              v-if="imgSrc == ''"
            />
            <input
              type="button"
              value="点击上传封面"
              class="btn firm-clickable"
              @click="clickFile()"
              v-if="imgSrc == ''"
            />
            <p v-if="imgSrc == ''">支持jpg、png格式，大小不超过300KB</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 案例编辑输入区 -->
    <div class="form-backdrop">
      <!-- 案例背景 -->
      <div class="container">
        <p class="container-title">
          <span style="color: red">*</span>案例背景：
        </p>
        <el-input
          type="textarea"
          placeholder="请输入至少15个字的案例背景，禁止填写联系方式（例：QQ、微信、手机号等）、广告及违法内容、一经发现则封禁店铺及账号，造成的损失由个人承担后果"
          v-model="ruleForm.textarea"
          maxlength="150"
          show-word-limit
          resize="none"
          :autosize="true"
        >
        </el-input>
      </div>
      <!-- 案例展示描述： -->
      <div class="container">
        <p class="container-title">
          <span style="color: red;">*</span>案例展示描述：
        </p>
        <el-input
          type="textarea"
          placeholder="请输入至少15个字的案例展示描述，禁止填写联系方式（例：QQ、微信、手机号等）、广告及违法内容、一经发现则封禁店铺及账号，造成的损失由个人承担后果"
          v-model="ruleForm.Description"
          maxlength="150"
          show-word-limit
          resize="none"
          :autosize="true"
        >
        </el-input>
      </div>
      <!-- 案例展示信息 -->
      <div class="container">
        <p class="container-title">
          <span style="color: red">*</span>案例展示信息：
        </p>
        <div class="case-show">富文本框位置</div>
      </div>
      <!-- 确认 -->
      <div class="verify-btn">
        <p>确 认</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        name: "", //案例名称
        value: [], //选择标签
        Price: "", //案例价格
        textarea: "", //案例背景
        Description: "", //案例展示描述
      }, //v-mode
      options: [], // 标签选项
      imgSrc: "",
      TXurl: "", //封面上传到腾讯云的地址
    };
  },
  watch: {},
  components: {},
  created() {},
  methods: {
    // 点击上传身份证
    clickFile(num) {
      // 上传正面
      const input = document.querySelector("#file");
      input.click();
    },
    // 调用上传文件/图片封装的js
    async onFileChange(event, opt) {
      var file = event.target.files[0] || event.dataTransfer.files[0];
      if (!file) return;
      let URL = window.URL || window.webkitURL;
      var arr = await this.$tool.onFileChangeNew(event, opt);
      if (arr && arr.code == 0) {
        this.imgSrc = URL.createObjectURL(file);
        this.TXurl = arr.TXurl;
      }
      if (this.$refs.clearFile) this.$refs.clearFile.value = "";
    },
    // 返回
    handelBack() {
      this.$emit("handelBack");
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 35px !important;
  border: 1px solid #409eff ;
  font-size: 12px;
}
// 文本输入框样式
/deep/.el-textarea {
  height: 100px !important;
  font-size: 12px;
}
/deep/.el-textarea__inner {
  height: 100px !important;
  border: 1px solid #409eff ;
}

// 外层div
.Case-box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 80px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
    .delete {
      width: 20px;
      height: 20px;
      background-image: url("../../../../../assets/imgs/shanchu@3x.svg");
      background-size: 100% 100%;
      position: absolute;
      right: 130px;
      top: 10px;
      cursor: pointer;
    }
  }
  // 编辑输入区
  .form-box {
    width: 100%;
    min-height: 100px;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    text-align: right;
    line-height: 17px;
    font-weight: 400;
    .aroundModule {
      width: 40%;
    }
  }
  .container {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    display: flex;
    margin-bottom: 20px;
    .container-title {
      min-width: 110px;
      text-align: right;
      font-size: 12px;
    }
    // 富文本框位置
    .case-show {
      width: 100%;
      min-height: 260px;
      border: 1px solid #eeeeee;
    }
    .Upload-box {
      width: 250px;
      height: 120px;
      border: 1px dashed #409eff ;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
      }
      #file {
        display: none;
      }
      #file1 {
        display: none;
      }
      input {
        border: none;
        box-shadow: none;
        outline: none;
        background-color: transparent;
        width: 100%;
        text-align: center;
        color: #409eff ;
        margin-top: 40px;
      }
      p {
        width: 100%;
        text-align: center;
        font-size: 10px;
      }
    }
  }
  // 编辑输入区
  .form-backdrop {
    width: 100%;
    min-height: 100px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    text-align: right;
    line-height: 17px;
    font-weight: 400;
  }
  // 确认按钮
  .verify-btn {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: flex-end;
    p {
      width: 100px;
      height: 30px;
      line-height: 30px;
      background: #409eff ;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
    }
  }
}
</style>
